export const muxEnvKey: string = process.env.REACT_APP_MUX_ENV_KEY!;
export const backendUrl: string = process.env.REACT_APP_API_URL!;
